'use client';
import dynamic from 'next/dynamic';

const AIChatWidget = dynamic(() => import('@/components/support/AIChatWidget'), {
  ssr: false,
});

export default function ChatWidgetLoader() {
  return <AIChatWidget />;
}
